import { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSnackbar } from "notistack";
// import {
//   _add_customer_api,
//   _detail_customer_for_admin_api,
//   _edit_customer_by_admin_api,
// } from "../../DAL/User/User";
import { useNavigate, useParams } from "react-router-dom";
import { Check } from "@mui/icons-material"; // Check icon

import { makeStyles } from "@mui/styles";
import { Icon } from "@iconify/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  add_Advisor_api,
  detail_advisor_api_for_Admin,
  update_Advisor_api,
} from "../../DAL/adminAuth/auth";
import { usStates } from "../../utils/constant";

const Input = styled("input")({
  display: "none",
});

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const AddOrUpdateAdvisor = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { user_id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
    status: true,
    caseCapacity: "",
    expertise: "",
    state: [], // for storing multiple selected states
  });

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "state") {
      // "value" is an array because of multiple
      if (value.includes("all")) {
        const allSelected = inputs.state.length === usStates.length;
        setInputs((prev) => ({
          ...prev,
          state: allSelected ? [] : usStates,
        }));
      } else {
        setInputs((prev) => ({
          ...prev,
          state: value,
        }));
      }
    } else {
      setInputs((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const get_user_detail = async () => {
    setIsEditLoading(true);
    const result = await detail_advisor_api_for_Admin(user_id);
    if (result.code === 200) {
      setInputs({
        ...result?.advisor,
      });
      setIsEditLoading(false);
    } else {
      setIsEditLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    const formData = new FormData();
    formData.append("name", inputs.name);
    formData.append("email", inputs.email);
    formData.append("phone", inputs.phone);
    formData.append("status", inputs.status);
    // formData.append("caseCapacity", inputs.caseCapacity);
    formData.append("expertise", inputs.expertise);
    formData.append("state", JSON.stringify(inputs.state));
    console.log(...formData, "formDataformDataformData");

    const result = user_id
      ? await update_Advisor_api(formData, user_id)
      : await add_Advisor_api(formData);
    if (result.code === 200) {
      navigate(`/list-advisors`);
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const EXPERTIES_OPTIONS = [
    "Frontend Developer",
    "Backend Developer",
    "Full Stack Developer",
    "UI/UX Designer",
    "QA Engineer",
    "Project Manager",
  ];
  useEffect(() => {
    if (user_id) {
      get_user_detail();
    } else {
      setIsEditLoading(false);
    }
  }, [user_id]);
  if (isEditLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="d-flex align-items-center">
          <IconButton
            className="back-screen-button "
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon />
          </IconButton>
          <div className="page-title-box">
            <h4>{user_id ? "Edit Attorney" : "Add Attorney"}</h4>
          </div>
        </div>
        <div className="col-12 col-md-6 mt-3">
          <TextField
            id="outlined-basic"
            label="Name"
            variant="outlined"
            fullWidth
            required
            name="name"
            value={inputs.name}
            placeholder="Name"
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6 mt-3">
          <TextField
            id="outlined-basic"
            label="Email"
            variant="outlined"
            required
            fullWidth
            name="email"
            value={inputs.email}
            placeholder="Email"
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6 mt-3">
          <TextField
            id="outlined-basic"
            label="Phone Number"
            variant="outlined"
            required
            fullWidth
            type="number"
            name="phone"
            value={inputs.phone}
            placeholder="Phone Number"
            onChange={handleChange}
          />
        </div>
        {/* <div className="col-12 col-md-6 mt-3">
          <TextField
            id="outlined-basic"
            label="Case Capacity %"
            variant="outlined"
            required
            fullWidth
            type="number"
            name="caseCapacity"
            value={inputs.caseCapacity}
            placeholder="Case Capacity 1 to 100%"
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              if (value >= 1 && value <= 100) {
                handleChange(e); // valid input
              } else if (!e.target.value) {
                handleChange(e); // allow empty value (for reset)
              }
            }}
            onKeyDown={(e) => {
              if (
                e.key === "0" &&
                (!e.target.value || e.target.value === "0")
              ) {
                e.preventDefault();
              }
            }}
            inputProps={{ min: 1, max: 100 }}
          />
        </div> */}

        <div className="col-12 col-md-6 mt-3">
          <FormControl fullWidth required>
            <InputLabel id="state-select-label">State</InputLabel>
            <Select
              labelId="state-select-label"
              id="state-select"
              name="state"
              multiple
              value={inputs.state}
              label="State"
              onChange={handleChange}
              renderValue={(selected) => selected.join(", ")}
            >
              <MenuItem value="all">
                <Checkbox
                  checked={inputs.state.length === usStates.length}
                  indeterminate={
                    inputs.state.length > 0 &&
                    inputs.state.length < usStates.length
                  }
                />
                <ListItemText primary="Select All" />
                {inputs.state.length === usStates.length && (
                  <Check fontSize="small" />
                )}
              </MenuItem>

              {usStates.map((state) => (
                <MenuItem key={state} value={state}>
                  <Checkbox checked={inputs.state.includes(state)} />
                  <ListItemText primary={state} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div className="col-12 col-md-6 mt-3">
          <FormControl fullWidth required>
            <InputLabel id="experties-label">Case Type</InputLabel>
            <Select
              labelId="experties-label"
              id="experties"
              name="expertise"
              value={inputs.expertise}
              label="Case Type"
              onChange={handleChange}
            >
              <MenuItem value="unwanted_spam">
                Unwanted Spam Texts/Calls
              </MenuItem>
              <MenuItem value="scam_recovery">Scam Recovery</MenuItem>
              <MenuItem value="both">Both</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="col-12 col-md-6 mt-3">
          <FormControl fullWidth required>
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="status"
              value={inputs.status}
              label="Status"
              onChange={handleChange}
            >
              <MenuItem value={true}>Active</MenuItem>
              <MenuItem value={false}>Inactive</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="d-flex justify-content-end mt-3">
          <Button type="submit" variant="contained">
            {user_id
              ? `${isLoading ? "Loading.." : " Update"}`
              : `${isLoading ? "Loading.." : "Submit"}`}{" "}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default AddOrUpdateAdvisor;
